module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "content",
      "src": "images/content.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/pagetitre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdd"
  }, [_c('span', {
    attrs: {
      "href": "#/ident1#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 Origins of Oil and Gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-001"
    }
  }, [_vm._v("A Brief Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-002"
    }
  }, [_vm._v("Subsea Burial")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-003"
    }
  }, [_vm._v("Hydrocarbon Generation within Source Rock")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-004"
    }
  }, [_vm._v("Migration to Reservoir Rock")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-005"
    }
  }, [_vm._v("Hydrocarbon Traps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-001"
    }
  }, [_vm._v("Structural traps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-002"
    }
  }, [_vm._v("Stratigraphic traps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-003"
    }
  }, [_vm._v("Combination traps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_vm._v("2 Oil Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-006"
    }
  }, [_vm._v("General Composition of Crude Oil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-007"
    }
  }, [_vm._v("Conventional Crude Oil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv2-004"
    }
  }, [_vm._v("Classiﬁcation scheme")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv2-005"
    }
  }, [_vm._v("Benchmark crudes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv2-006"
    }
  }, [_vm._v("Crude oil prices")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-008"
    }
  }, [_vm._v("Unconventional Crude Oil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv2-007"
    }
  }, [_vm._v("Tar sands/oil sands")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv2-008"
    }
  }, [_vm._v("Shale oil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-009"
    }
  }, [_vm._v("Resources and Reserves")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-010"
    }
  }, [_vm._v("Recent Trends in U.S. Oil Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-011"
    }
  }, [_vm._v("Products Created from Oil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-012"
    }
  }, [_vm._v("Recent Trends in Oil Consumption")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-013"
    }
  }, [_vm._v("Projected Trends in Oil Consumption")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#appen1"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Natural Gas Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Formation and Composition of Natural Gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conventional Natural Gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unconventional Natural Gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tight gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shale gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coal-bed methane")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Geopressurized gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Methane hydrate")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources and Reserves")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recent Trends in Gas Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Projected Trends in Gas Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recent and Projected Trends in Gas Consumption")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#appen2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Searching for and Evaluating Oil and Gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obtaining Rights to Explore for and Produce Oil and Gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Production-sharing agreement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Service contract")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Production contract")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exploration Activities")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Geologic methods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Geochemical methods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Geophysical methods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Survey Methods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gravimetric survey")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magnetic survey")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seismic survey")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exploratory Drilling")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evaluation Methods and Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Well logging")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Real-time methods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other evaluation methods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making the Decision to Begin Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Development economics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Technical and operational factors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Drilling and Completion: Onshore")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Site Preparation and Well Construction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rotary Drilling")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prime mover")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hoisting equipment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rotating equipment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drill bit")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Circulating system")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blowout prevention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drilling techniques")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drilling problems")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Well Testing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onshore Well Completion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Casing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bottom-hole treatment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tubing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wellhead and related equipment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Well Treatment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acidizing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hydraulic fracturing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Drilling and Completion: Offshore")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exploratory Drilling")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drilling barge")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mobile offshore drilling unit")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Well Completion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fixed Development and Production Platforms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steel-jacket platform")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gravity-based platform")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tension-leg platform")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compliant-tower platform")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Floating Development and Production Platforms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Semisubmersible vessel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monohull platform (FPSO)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spar platform")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Managing Oil and Gas Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Start of Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artiﬁcial Lift")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Workover of a Well")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Workover actions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sidetrack well")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recompletion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Workover of offshore wells")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Improved Oil Recovery")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waterﬂood")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gas injection")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chemical ﬂood")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thermal recovery")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gas Production Management—an Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initial Gas Treatment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gas Processing Operations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Removal of carbon dioxide and hydrogen sulﬁde")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Removal of water vapor")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Removal of heavier hydrocarbon gases")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nitrogen removal")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helium removal")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Environmental Issues in Gas Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Production Ends")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Transporting Oil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preliminary Crude Processing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pipeline Networks")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pipe")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other components")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inspection and maintenance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Offshore Pipelines")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From wellhead to platform")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From platform to shore")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oil Tanker Ships")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Railcars and Tank Trucks")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oil Storage")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPRs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Transporting Natural Gas by Pipeline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview of Gas Transportation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transmission Systems")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U.S. gas transmission")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic pipeline equipment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gas storage")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inspection and maintenance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Global gas transmission")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distribution Systems")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City gate station")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piping network")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piping materials")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Minimizing gas leakage")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Controlling corrosion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peak-shaving")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Transporting Natural Gas as LNG")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Background")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Liquefaction Process")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LNG Storage Tanks")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Offshore Liquefaction Concepts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LNG Tanker Ships")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onshore Regasiﬁcation Process")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Offshore Regasiﬁcation Process")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LNG Safety")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Converting Oil into Products")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview of Reﬁning")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Separation/Distillation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conversion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cracking")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modiﬁcation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enhancement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hydroprocessing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amine treating")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solvent extraction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweetening")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blending/Finishing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gasoline blendstocks")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gasoline additives")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Reﬁneries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classiﬁcation by complexity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classiﬁcation by capacity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reﬁnery Maintenance Schedules")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Product Pipelines")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finished petroleum products")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petrochemicals and LPGs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standards for Reﬁned Products")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petrochemicals Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Converting Natural Gas into Products")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Direct Gas Use as a Fuel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gas as a Petrochemical Feedstock")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethane")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Propane and butane")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gas-to-Liquids Technology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Products Derived from Natural Gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Petroleum Industry Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major Oil and Gas Producers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seven Sisters, supermajors, and international oil companies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("National oil companies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hybrid companies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Independent Producers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Service Companies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IOC-NOC Interactions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPEC")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPEC history")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPEC membership")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPEC outlook")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reﬁners")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Independent reﬁners")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("World reﬁning capacity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Largest reﬁners and reﬁneries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reﬁnery projects planned for 2010 and beyond")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Petroleum Trading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oil Trading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physical versus paper trading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pricing—a historical perspective")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oil pricing today")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pricing along the delivery chain")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Posted prices")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hubs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transportation services")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sale and movement of reﬁned products")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petroleum product marketers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gasoline distribution and marketing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natural Gas Trading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U.S. historical perspective")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physical delivery of natural gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hubs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Financial gas market")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LDC role in gas marketing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LNG trading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Emerging Challenges for the Petroleum Industry")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continued Technology Development")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Competition from Nonfossil Energy Sources")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climate-Change Policy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Industry Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Industry Operations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Workforce demographics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Role of natural gas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crude oil quality")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Environmental and safety compliance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Security")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chinese Challenge")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other International Interactions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peak Oil Production")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Terms, Abbreviations, and Acronyms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4#niv1-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Technical Books and Professional Articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4#niv1-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Interest")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4#niv1-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Information Sources")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Organizations, Agencies, and Professional Societies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5#niv1-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trade Associations and Professional Societies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5#niv1-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U.S. Government Agencies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5#niv1-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("International Energy Organizations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 66
// module chunks = 0